/**
 * 量化模块接口列表
 */

import base from './base'; // 导入接口域名列表
import axios from './axios';
import qs from 'qs';
//获取策略
export const getListStrategy = (params) => {
    return axios.post(`${base.base}/trade/get_list_strategy`,
        qs.stringify(params)
    )
};
//获取策略升级接口
export const getListStrategyPro = (params) => {

    return axios.post(`${base.base}/trade/get_list_strategy_pro`,
        qs.stringify(params)
    )
};
export default getListStrategy;


// WEBPACK FOOTER //
// ./src/api/quant.js